import { addDays, startOfWeek } from 'date-fns';

import { CALENDAR_WEEK_STARTS_ON } from '@/app/(main)/calendar/consts/calendar-week';

export function getWeekRangeForDate(date: Date): { weekStart: Date; weekEnd: Date } {
  const weekStart = startOfWeek(date, { weekStartsOn: CALENDAR_WEEK_STARTS_ON });
  return { weekStart, weekEnd: addDays(weekStart, 6) };
}

export function getWeekStripDays(selectedDate: Date): Date[] {
  const { weekStart } = getWeekRangeForDate(selectedDate);
  return Array.from({ length: 7 }, (_, index) => addDays(weekStart, index));
}
